/** Middle-truncate long ids: 0199a6f2…3e1c. */
export function shortId(value: string, head = 8, tail = 4): string {
  if (value.length <= head + tail + 1) return value;
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
}

/** "1 invoice" / "3 invoices" */
export function plural(count: number, singular: string, pluralForm = `${singular}s`): string {
  return `${count.toLocaleString()} ${count === 1 ? singular : pluralForm}`;
}

/** Compact, readable JSON for payload viewers. */
export function prettyJson(value: unknown): string {
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

/** Interval label: ("month", 1) → "Monthly", ("month", 3) → "Every 3 months". */
export function intervalLabel(
  interval: string | null | undefined,
  count: number | null | undefined = 1,
): string {
  if (!interval) return 'One time';
  const n = count ?? 1;
  if (n === 1) {
    return { day: 'Daily', week: 'Weekly', month: 'Monthly', year: 'Yearly' }[interval] ?? interval;
  }
  return `Every ${n} ${interval}s`;
}

/** "/month", "/3 months" suffix for recurring prices. */
export function perInterval(
  interval: string | null | undefined,
  count: number | null | undefined = 1,
): string {
  if (!interval) return '';
  const n = count ?? 1;
  return n === 1 ? `/${interval}` : `/${n} ${interval}s`;
}

/** "Ada Lovelace" → "AL" */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase() || '?';
}

/** Ends a sentence with a period unless the text already ends in one ("Acme Inc."). */
export function endSentence(text: string): string {
  return /[.!?]$/.test(text) ? text : `${text}.`;
}

/** Addresses typed as a list separated by commas, semicolons or spaces. */
export function emailList(value: string): string[] {
  return value
    .split(/[\s,;]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}
